import React from 'react';

/**
 * Renders text nodes with linebreaks as <br/>.
 */
export default function Text(_ref) {
  var children = _ref.children;
  return React.Children.map(children, function (child) {
    if (typeof child === 'string') {
      return withLineBreaks(child);
    }
    return child;
  });
}

/**
 * Converts a text with line breaks into <br/> React elements.
 * @param {C} text
 */
function withLineBreaks(text) {
  var splat = text.split('\n');
  var result = [];
  for (var i = 0; i < splat.length; i++) {
    var val = splat[i];
    if (val) {
      result.push(val);
    }
    if (i < splat.length - 1) {
      result.push(/*#__PURE__*/React.createElement('br'));
    }
  }
  return result;
}
//# sourceMappingURL=index.js.map
